try {
    require('./init')
    require('./stacks-status/app')
} catch (e) {
    console.error(e)
}
